import { createSlice } from '@reduxjs/toolkit'
import { setIsClearingReduxFormState } from 'state/ui'

const initialState = {
  mergeTickets: {
    shouldMergeTickets: false,
    ibtIds: [],
  },
}

export const billInfoSlice = createSlice({
  name: 'bill',
  initialState,
  reducers: {
    setMergeTicketsState: (state, action) => {
      state.mergeTickets = action.payload
    },
    clearMergeTicketsState: state => {
      state.mergeTickets = initialState.mergeTickets
    },
  },
  extraReducers: builder => {
    builder.addCase(setIsClearingReduxFormState, (state, action) => {
      if (action.payload) {
        state.mergeTickets = initialState.mergeTickets
      }
    })
  },
})

export const { setMergeTicketsState, clearMergeTicketsState } = billInfoSlice.actions

export default billInfoSlice.reducer
